
import { QueryClient } from '@tanstack/react-query';

// Single shared QueryClient for the entire app.
// IMPORTANT: AppProviders must use this same instance, otherwise cache invalidation
// won't update the UI.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
      retryDelay: 1000,
    },
  },
});
